module.exports = __webpack_public_path__ + "static/assets/25d38cbbfa634f9cbf0d15911db902c0.png";